<template>
  <component
    :is="tag"
    class="selectable-card"
    :class="{ 'selectable-card--selected': isSelected }"
    @click="$emit('select', item)"
  >
    <div class="selectable-card__content">
      <div class="selectable-card__media">
        <slot name="media" />
        <div
          v-if="$slots.overlayTopLeft"
          class="selectable-card__overlay selectable-card__overlay--top-left"
        >
          <slot name="overlayTopLeft" />
        </div>
        <div
          v-if="$slots.overlayTopRight"
          class="selectable-card__overlay selectable-card__overlay--top-right"
        >
          <slot name="overlayTopRight" />
        </div>
        <div
          v-if="$slots.overlayBottom"
          class="selectable-card__overlay selectable-card__overlay--bottom"
        >
          <slot name="overlayBottom" />
        </div>
      </div>
      <div class="selectable-card__body">
        <slot name="body" />
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
defineProps({
  item: {
    type: Object,
    required: true
  },
  isSelected: {
    type: Boolean,
    required: true
  },
  tag: {
    type: String,
    default: 'div'
  }
})
defineEmits(['select'])
</script>
